import {
  FormErrorMessage as ChakraFormErrorMessage,
  FormErrorMessageProps as ChakraFormErrorMessageProps,
} from '@chakra-ui/react';

const FormErrorMessage = ({ children, ...props }: ChakraFormErrorMessageProps) => (
  <ChakraFormErrorMessage {...props}>{children}</ChakraFormErrorMessage>
);

export { FormErrorMessage };
